import { render, staticRenderFns } from "./subscribe.vue?vue&type=template&id=3c22054e&scoped=true&"
import script from "./subscribe.vue?vue&type=script&lang=js&"
export * from "./subscribe.vue?vue&type=script&lang=js&"
import style0 from "./subscribe.vue?vue&type=style&index=0&id=3c22054e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22054e",
  null
  
)

export default component.exports